import {DefaultLanguage} from '@/plugins/i18n'

const getters = {
  isInitialized: state => {
    return state.isInitialized ? state.isInitialized : false
  },
  isLoading: state => {
    return state.isLoading ? state.isLoading : false
  },
  locale: state => {
    return state.locale ? state.locale : DefaultLanguage
  },
  adminId: () => 1966,
  user: ({user}) => user,
  isAdmin: ({user}) => user.isadmin,
  isAuthenticated: state => state.authenticated,

  notifications: ({notifications}) => notifications,
  notificationsList: ({notifications}) => notifications.list,
  unreadNotificationsCount: ({notifications, user}) => (notifications.list ? notifications.list.reduce((count, {isUnread, fromEmail}) => (fromEmail === user.email ? count : count + Number(isUnread)) , 0) : 0),
  notificationsPollingInterval: ({notificationsPollingInterval}) => notificationsPollingInterval,

  rightsholders: ({rightsholders}) => rightsholders,
  currentRightsholder: ({currentRightsholderData, currentRightsholderId}) => currentRightsholderData || {id: currentRightsholderId},
  currentRightsholderReady: ({currentRightsholderId}) => currentRightsholderId !== null,
  rightsholder: ({rightsholders}) => (rhId) => rightsholders.list.find(({id}) => rhId === id),

  statements: ({statements}) => statements,
  statementsList: ({statements}) => statements.list,

  currentRights: ({rights}) => rights,


  unclaimedRights: ({unclaimed}) => unclaimed,

  staging: ({staging}) => staging,

  claimforms: ({claimforms}) => claimforms,

  homeContent: state => state.homeContent,

  startContent: state => state.startContent,

  dialogContent: state => state.dialogContent,
}

export default getters
